// extracted by mini-css-extract-plugin
export default {"productsGrid":"ProductsGrid_productsGrid__UVmyn","productCell":"ProductsGrid_productCell__SxApp"};